<main class="mb-4">
  <div class="row ">
    <div class="col-sm-12">
      <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepSender.Cards.SenderContacts.Title' | translate}}</h2>
    </div>
  </div>

  <div class="row ">

    <!--País-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset  [disabled]="isFieldDisabled('countryCode')  || qualification.isServiceOrFunerary?.toString() == 'true' || isCertified?.toString()=='true'">
          <label for="country" [class.disabled]="isFieldDisabled('countryCode')  || qualification.isServiceOrFunerary?.toString() == 'true' || isCertified?.toString()=='true'">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Country' | translate}}
          </label>
          <select class="custom-select" [(ngModel)]="model.countryCode" name="country" #country="ngModel" required
                  [clearRelated]="{model : this.model , propsToReset : ['postalCode','locality','postalDesignation','postalCodeFull','telephone']} "
                  [dropdownTitle]="{value : model.countryCode, dimensions :  countries }"
                  (ngModelChange)="countryChanged()"
                  nullableSelect>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of countries" [value]="domain.code">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="country"></validation-message>
        </fieldset>
      </div>
    </div>

    <!--Morada-->
    <div class="col-sm-8">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('address')  || qualification.isServiceOrFunerary?.toString() == 'true' || isCertified?.toString()=='true'">
          <label for="address"  [class.disabled]="isFieldDisabled('address')  || qualification.isServiceOrFunerary?.toString() == 'true' || isCertified?.toString()=='true'">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Address' | translate}}
          </label>
          <div class="position-relative">
            <input class="form-control input-right" type="text" [(ngModel)]="model.address"
                   #address="ngModel" name="address"
                    maxlength="80"
                   required messageFieldType="string"
                   style='text-transform:uppercase'>

            <validation-message [control]="address"></validation-message>
          </div>
         </fieldset>
      </div>
    </div>

  </div>

  <div class="row ">

    <!--Código Postal-->
    <div class="col-sm-4" *ngIf="model.countryCode=='PT' || model.countryCode==undefined">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('postalCodeFirst')  || qualification.isServiceOrFunerary?.toString() == 'true' || isCertified?.toString()=='true'">
          <label for="postalCodeFirst" [class.disabled]="isFieldDisabled('postalCodeFirst')  || qualification.isServiceOrFunerary?.toString() == 'true' || isCertified?.toString()=='true'">
            <span class="mandatory">*</span>
            {{'CardSubscriberContacts.PostalCode' | translate}}
          </label>
          <div class="form-row">
            <div class="col-sm-6">
              <input class="form-control" type="text" numeric="4" placeholder="{{'Placeholders.Generic.PostalCodeFirst4' | translate}}"
                     [(ngModel)]="model.postalCodeFirst" name="postalCodeFirst"
                     #postalCodeFirst="ngModel" exactLength="4" required
                     (ngModelChange)="onPostalCodeChanged()">
              <validation-message [control]="postalCodeFirst"></validation-message>
            </div>
            <div class="col-sm-6">
              <input class="form-control" type="text" numeric="3" placeholder="{{'Placeholders.Generic.PostalCodeLast3' | translate}}"
                     [(ngModel)]="model.postalCodeLast" name="postalCodeLast"
                     #postalCodeLast="ngModel" exactLength="3" pattern="\d*" required
                     (ngModelChange)="onPostalCodeChanged()">
              <validation-message [control]="postalCodeLast"></validation-message>
            </div>
          </div>
        </fieldset>
      </div>
    </div>

    <div class="col-sm-4" *ngIf="model.countryCode!='PT' && model.countryCode!=undefined">
      <div class="form-group">
        <fieldset>
          <label for="postalCodeFull"  [class.disabled]="isFieldDisabled('postalCodeFull')  || qualification.isServiceOrFunerary?.toString() == 'true' || isCertified?.toString()=='true'">
            <span class="mandatory">*</span>
            {{'CardSubscriberContacts.PostalCode' | translate}}
          </label>
          <input class="form-control" type="text" placeholder="{{'Placeholders.Generic.ForeignPostalCode' | translate}}"
                 [(ngModel)]="model.postalCodeFull" name="postalCodeFull" #postalCodeFull="ngModel" required maxlength="20">
          <validation-message [control]="postalCodeFull"></validation-message>
        </fieldset>
      </div>
    </div>

    <!--Designação postal-->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="postalDesignation" class="disabled">
          <span class="mandatory" *ngIf="model.countryCode=='PT'">*</span>
          {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.PostalDesignation' | translate}}
        </label>
        <div class="position-relative">
          <input class="form-control input-right" type="text" [(ngModel)]="model.postalDesignation"
                 #postalDesignation="ngModel" name="postalDesignation"
                 messageFieldType="string" disabled [required]="model.countryCode=='PT'">

          <validation-message [control]="postalDesignation"></validation-message>
        </div>
      </div>
    </div>

    <!--Localidade-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('locality')  || qualification.isServiceOrFunerary?.toString() == 'true' || isCertified?.toString()=='true'">
          <label for="locality" [class.disabled]="isFieldDisabled('locality')  || qualification.isServiceOrFunerary?.toString() == 'true' || isCertified?.toString()=='true'">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Locality' | translate}}
          </label>
          <div class="position-relative">
            <input class="form-control input-right" type="text" [(ngModel)]="model.locality"
                   #locality="ngModel" name="locality"
                   required messageFieldType="string"
                   style='text-transform:uppercase'>

            <validation-message [control]="locality"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>
  </div>

  <div class="row ">

    <!--Telefone Fixo-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('telephone') || qualification.isServiceOrFunerary?.toString() == 'true'">
          <label for="telephone"  [class.disabled]="isFieldDisabled('telephone') || qualification.isServiceOrFunerary?.toString() == 'true'">
            <!--<span class="mandatory" *ngIf="qualification.isServiceOrFunerary?.toString() != 'true'">*</span>-->
            {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Telephone' | translate}}
          </label>
          <div class="position-relative">
            <input class="form-control input-right" type="text" [(ngModel)]="model.telephone"
                   #telephone="ngModel" name="telephone"
                   messageFieldType="string" [pattern]="landlinePattern"
                   />

            <validation-message [control]="telephone"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

    <!--Telemóvel-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('mobilePhone') || model.isMobileCertified?.toString()=='true' || qualification.isServiceOrFunerary?.toString() == 'true'">
          <label for="mobilePhone"  [class.disabled]="isFieldDisabled('mobilePhone') || model.isMobileCertified?.toString()=='true' || qualification.isServiceOrFunerary?.toString() == 'true'">
              <span class="mandatory" *ngIf="qualification.isServiceOrFunerary?.toString() != 'true'">*</span>
              {{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.MobilePhone' | translate}}
              <button type="button"
                    class="btn-icon text-primary icon-help"
                    aria-label="Tooltip com informação"
                    tooltip="{{'Tooltips.CardSubscriberContacts.MobileNumber' | translate}}"></button>
          </label>
          <div class="position-relative">
            <input class="form-control input-right" type="text" [(ngModel)]="model.mobilePhone"
                   #mobilePhone="ngModel" name="mobilePhone"
                   [required]="qualification.isServiceOrFunerary?.toString() != 'true'" messageFieldType="string"
                   [pattern]="mobilePattern">

            <validation-message [control]="mobilePhone"></validation-message>
          </div>
         </fieldset>
      </div>
    </div>

    <!--E-mail-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('email')">
          <label for="email" class="disabled">
            <span class="mandatory">*</span>{{'PrestacoesMorte.StepSender.Cards.SenderContacts.Fields.Email' | translate}}
            <button type="button"
                    class="btn-icon text-primary icon-help"
                    aria-label="Tooltip com informação"
                    disabled
                    tooltip="{{'Tooltips.CardSubscriberContacts.Email' | translate}}"></button>
          </label>
          <div class="position-relative">
            <input class="form-control input-right" type="text" [(ngModel)]="model.email"
                   #email="ngModel" name="email"
                   required messageFieldType="string" disabled>

            <validation-message [control]="email"></validation-message>

          </div>
        </fieldset>
      </div>
    </div>
  </div>


</main>
